import { useState } from "react";
import { ErrorToast } from "../../toast/Toasts";
import useWindowSize from "../../_hooks/useWindowSize";
import { useLocation } from "react-router";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { FormikProps } from "formik";
import { IReviewBookingDetails } from "./reviewbookingModel";
import {
  calculateFareDetails,
  calculateGiftCodeDiscount,
} from "../../_helpers/fareUtils";
import { formatIndianNumber } from "../../_helpers/formatUtils";
import { RxCrossCircled } from "react-icons/rx";
import Modal from "../../components/modal/Modal";

const ReviewPriceCard = ({
  flightReviewDetails,
  otherServices,
  // handleSubmit,
  // handleValidationComplete,
  // errors,
  convenienceFeeWithGST = 0,
  // isNotContinue,
  btnText,
  appliedPromo,
  appliedPromoAmount = 0,
  formik,
  handlePromoCodeApply,
  handlePromoCodeRemove,
  useWallet = false,
  setUseWallet,
  walletAmount = 0,
  setWalletAmount,
  isProcessingPayment,
  appliedGiftCode,
  handleGiftCodeRemove,
  handleGiftCodeApply,
  handleGiftCodeOtpVerify,
  showOtpModal,
  setShowOtpModal,
  appliedGiftCodeAmount = 0,
  creditLimitAmount,
  useCreditLimit,
  setUseCreditLimit,
  setCreditLimitAmount,
  availableCreditLimit,
}: {
  flightReviewDetails: any;
  otherServices: any[];
  // errors: any;
  btnText: string;
  appliedPromo: any;
  appliedPromoAmount: number;

  showOtpModal: boolean;
  appliedGiftCode: any;
  handleGiftCodeRemove: () => void;
  handleGiftCodeApply: () => void;
  handleGiftCodeOtpVerify: () => void;
  setShowOtpModal: (show: boolean) => void;
  appliedGiftCodeAmount: number;

  formik: FormikProps<IReviewBookingDetails>;
  convenienceFeeWithGST: number;
  // isNotContinue: boolean;
  // handleSubmit: () => void;
  // handleValidationComplete?: (data: any) => boolean;
  handlePromoCodeApply: () => void;
  handlePromoCodeRemove: () => void;
  useWallet: boolean;
  setUseWallet: (used: boolean) => void;
  walletAmount: number;
  setWalletAmount: (amount: number) => void;
  isProcessingPayment: boolean;
  useCreditLimit: boolean;
  setUseCreditLimit: (used: boolean) => void;
  creditLimitAmount: number;
  setCreditLimitAmount: (amount: number) => void;
  availableCreditLimit: number;
}) => {
  const [activeTabs, setActiveTabs] = useState<any>([]);
  const { width } = useWindowSize();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const promoapplyLoading = useAppSelector(
    (state) => state.reviewbooking.promoapplyLoading
  );

  const giftcodeapplyLoading = useAppSelector(
    (state) => state.reviewbooking.giftcodeapplyLoading
  );

  // const handlingFees = useAppSelector(
  //   (state) => state.reviewbooking.handlingFees
  // );

  // const paxes = extractPaxFromUrl(location.search);

  const walletDetails = useAppSelector((state) => state.wallet.walletDetails);

  const totalOtherFee = otherServices?.reduce((acc: number, fee: any) => {
    return (acc = acc + (fee?.amount || 0));
  }, 0);

  const ADULT = location?.state?.ADULT || 0;
  const CHILD = location?.state?.CHILD || 0;
  const INFANT = location?.state?.INFANT || 0;

  // const isInternational = isInternationalFlight(
  //   flightReviewDetails?.flatMap((item: any) => item.Flight?.Segments || [])
  // );

  // const baseConvenienceFee = isInternational
  //   ? handlingFees?.International_Conv_Fee || 0
  //   : handlingFees?.Domestic_Conv_Fee || 0;

  // const gstAmount = (baseConvenienceFee * handlingFees?.GSTPer) / 100;
  // const convenienceFeeWithGST =
  //   (baseConvenienceFee + gstAmount) * (ADULT + CHILD);

  const fareDetails = calculateFareDetails(
    flightReviewDetails,
    location?.state
  );

  const RefundableType =
    flightReviewDetails &&
    flightReviewDetails[0] &&
    flightReviewDetails[0]?.Flight?.Fares &&
    flightReviewDetails[0]?.Flight?.Fares[0]?.Refundable
      ? "Refundable"
      : "Non Refundable";

  const totalAmount =
    fareDetails?.overall?.basic +
    fareDetails?.overall?.taxes +
    // fareDetails?.overall?.serviceAmount +
    totalOtherFee +
    convenienceFeeWithGST;

  const payableAmount =
    totalAmount -
    appliedPromoAmount -
    appliedGiftCodeAmount -
    (useWallet ? walletAmount : 0) -
    (useCreditLimit ? creditLimitAmount : 0);

  const toggleTab = (index: number) => {
    setActiveTabs((prev: any) => {
      if (prev.includes(index)) {
        return prev.filter((i: number) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleWalletToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setUseWallet(checked);
    if (!checked) {
      setWalletAmount(0);
    } else {
      // Set default wallet amount to either full balance or payable amount, whichever is smaller
      const maxAllowed = Math.min(
        walletDetails?.wallet_balance,
        payableAmount + walletAmount
      );
      setWalletAmount(maxAllowed);
    }
  };

  const handleWalletAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value) || 0;
    const maxAllowed = Math.min(
      walletDetails?.wallet_balance,
      payableAmount + walletAmount
    );
    setWalletAmount(Math.min(value, maxAllowed));
  };

  const handleCreditLimitToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setUseCreditLimit(checked);
    if (!checked) {
      setCreditLimitAmount(0);
    } else {
      // Set default credit amount to either full balance or payable amount, whichever is smaller
      const maxAllowed = Math.min(
        availableCreditLimit,
        payableAmount + creditLimitAmount
      );
      setCreditLimitAmount(maxAllowed);
    }
  };

  const handleCreditLimitAmountChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseFloat(e.target.value) || 0;
    const maxAllowed = Math.min(
      availableCreditLimit,
      payableAmount + creditLimitAmount
    );
    setCreditLimitAmount(Math.min(value, maxAllowed));
  };

  return (
    <div className="col-lg-4 col-md-5 col-sm-12">
      <div
        className="sticky-right-price-card"
        style={{ top: width <= 991 ? 0 : 100 }}
      >
        <div className="listing-sidebar booking-sidebar">
          <div className="d-flex-space-between mb-3">
            <h4>Fare Summary</h4>
            <h4>{ADULT + CHILD + INFANT} Traveller</h4>
          </div>
          <div className="d-flex-space-between mb-3">
            <h5>Fare Type</h5>
            <h5>{RefundableType}</h5>
          </div>
          <div
            className={`sidebar-tab ${
              activeTabs.includes(1) ? "menu-active" : ""
            }`}
          >
            <div className="d-flex-space-between">
              <h5 onClick={() => toggleTab(1)}>{"Base Fare"}</h5>
              <h6>₹ {formatIndianNumber(fareDetails?.overall?.basic)}</h6>
            </div>
            {activeTabs.includes(1) && (
              <div className="sidebar-content flex-column">
                {fareDetails?.adults?.basic > 0 && ADULT > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Adult(s) ({formatIndianNumber(fareDetails?.adults?.basic)}{" "}
                      x {ADULT})
                    </span>
                    <span>
                      ₹ {formatIndianNumber(fareDetails?.adults?.basic * ADULT)}
                    </span>
                  </div>
                )}
                {fareDetails?.children?.basic > 0 && CHILD > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Children (
                      {formatIndianNumber(fareDetails?.children?.basic)} x{" "}
                      {CHILD})
                    </span>
                    <span>
                      ₹{" "}
                      {formatIndianNumber(fareDetails?.children?.basic * CHILD)}
                    </span>
                  </div>
                )}
                {fareDetails?.infants?.basic > 0 && INFANT > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Infant(s) (
                      {formatIndianNumber(fareDetails?.infants?.basic)} x{" "}
                      {INFANT})
                    </span>
                    <span>
                      ₹{" "}
                      {formatIndianNumber(fareDetails?.infants?.basic * INFANT)}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className={`sidebar-tab ${
              activeTabs.includes(2) ? "menu-active" : ""
            }`}
          >
            <div className="d-flex-space-between">
              <h5 onClick={() => toggleTab(2)}>{"Taxes & Fees"}</h5>
              <h6>
                ₹{" "}
                {formatIndianNumber(
                  fareDetails?.overall?.taxes +
                    // fareDetails?.overall?.serviceAmount +
                    // fareDetails?.overall?.trademarkupAmount +
                    totalOtherFee
                )}
              </h6>
            </div>
            {activeTabs.includes(2) && (
              <div className="sidebar-content flex-column">
                {fareDetails?.adults?.taxes > 0 && ADULT > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Adult(s) ({formatIndianNumber(fareDetails?.adults?.taxes)}{" "}
                      x {ADULT})
                    </span>
                    <span>
                      ₹ {formatIndianNumber(fareDetails?.adults?.taxes * ADULT)}
                    </span>
                  </div>
                )}
                {fareDetails?.children?.taxes > 0 && CHILD > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Children (
                      {formatIndianNumber(fareDetails?.children?.taxes)} x{" "}
                      {CHILD})
                    </span>
                    <span>
                      ₹{" "}
                      {formatIndianNumber(fareDetails?.children?.taxes * CHILD)}
                    </span>
                  </div>
                )}
                {fareDetails?.infants?.taxes > 0 && INFANT > 0 && (
                  <div className="sidebar-row">
                    <span>
                      Infant(s) (
                      {formatIndianNumber(fareDetails?.infants?.taxes)} x{" "}
                      {INFANT})
                    </span>
                    <span>
                      ₹{" "}
                      {formatIndianNumber(fareDetails?.infants?.taxes * INFANT)}
                    </span>
                  </div>
                )}
                {/* {fareDetails?.overall?.serviceAmount > 0 && (
                  <div className="sidebar-row">
                    <span>Service fee</span>
                    <span>
                      ₹{" "}
                      {formatIndianNumber(fareDetails?.overall?.serviceAmount)}
                    </span>
                  </div>
                )} */}
                {otherServices?.map((e: any) => {
                  return (
                    <div className="sidebar-row">
                      <span>{e?.label}</span>
                      <span>₹ {formatIndianNumber(e?.amount)}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {convenienceFeeWithGST > 0 && (
            <div className="d-flex-space-between mb-3">
              <div className="sidebar-left">
                <h5 className="m-0">Convenience Fee</h5>
              </div>
              <div className="sidebar-right">
                <h5 className="m-0">
                  ₹ {formatIndianNumber(convenienceFeeWithGST)}
                </h5>
              </div>
            </div>
          )}
          <div className="sidebar-content siderbar-total pb-2">
            <div className="sidebar-left">
              <h5>Total Amount</h5>
            </div>
            <div className="sidebar-right">
              <h5>₹ {formatIndianNumber(totalAmount)}</h5>
            </div>
          </div>
          {(appliedPromoAmount > 0 || appliedGiftCodeAmount > 0) && (
            <div
              className={`sidebar-tab ${
                activeTabs.includes(3) ? "menu-active" : ""
              }`}
            >
              <div
                className="d-flex-space-between"
                style={{ color: "#00a34d" }}
              >
                <h5 onClick={() => toggleTab(3)}>{"Discount"}</h5>
                <h6>
                  - ₹{" "}
                  {formatIndianNumber(
                    appliedPromoAmount + appliedGiftCodeAmount
                  )}
                </h6>
              </div>
              {activeTabs.includes(3) && (
                <div className="sidebar-content flex-column">
                  {fareDetails?.adults?.taxes > 0 && ADULT > 0 && (
                    <>
                      {appliedPromoAmount > 0 && (
                        <div className="sidebar-row">
                          <span style={{ color: "#00a34d" }}>
                            {appliedPromo?.PromoCode}
                          </span>
                          <span style={{ color: "#00a34d" }}>
                            - ₹ {formatIndianNumber(appliedPromoAmount)}
                          </span>
                        </div>
                      )}
                      {appliedGiftCodeAmount > 0 && (
                        <div className="sidebar-row">
                          <span style={{ color: "#00a34d" }}>
                            {appliedGiftCode?.GiftCode}
                          </span>
                          <span style={{ color: "#00a34d" }}>
                            - ₹ {formatIndianNumber(appliedGiftCodeAmount)}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          )}
          {walletAmount > 0 && (
            <div className="d-flex-space-between mb-3">
              <div className="sidebar-left">
                <h5 className="m-0">Used Wallet Amount</h5>
              </div>
              <div className="sidebar-right">
                <h5 className="m-0" style={{ color: "#00a34d" }}>
                  - ₹ {formatIndianNumber(walletAmount)}
                </h5>
              </div>
            </div>
          )}
          {creditLimitAmount > 0 && (
            <div className="d-flex-space-between mb-3">
              <div className="sidebar-left">
                <h5 className="m-0">Used Credit Limit</h5>
              </div>
              <div className="sidebar-right">
                <h5 className="m-0" style={{ color: "#00a34d" }}>
                  - ₹ {formatIndianNumber(creditLimitAmount)}
                </h5>
              </div>
            </div>
          )}
          <div className="sidebar-content siderbar-total">
            <div className="sidebar-left">
              <h5>Payable Amount</h5>
            </div>
            <div className="sidebar-right">
              <h5>
                ₹{" "}
                {formatIndianNumber(
                  totalAmount -
                    appliedPromoAmount -
                    appliedGiftCodeAmount -
                    walletAmount -
                    creditLimitAmount
                )}
              </h5>
            </div>
          </div>
          <a
            className="fill-btn"
            href="javascript:void(0)"
            onClick={async () => {
              const userGuid = localStorage.getItem("user_guid");
              // const isEmailVerified = localStorage.getItem("is_email_verified");

              if (!userGuid) {
                return ErrorToast("Please login to book a flight!!!");
              }

              if (isProcessingPayment) return;

              // let verified = isEmailVerified === "true";

              // if (!verified) {
              //   const res = await dispatch(
              //     getLoginDetailsByID({ user_guid: userGuid })
              //   );
              //   verified = res?.payload?.is_email_verified === true;
              // }

              // if (!verified) {
              //   return ErrorToast(
              //     "Please verify your email from profile to book a flight!!!"
              //   );
              // }

              // if (
              //   handleValidationComplete &&
              //   handleValidationComplete(formik?.errors)
              // ) {
              formik?.handleSubmit();
              // if (isNotContinue) {
              //   ErrorToast("Seat selection remaining");
              // }
              // }
            }}
          >
            {btnText}
          </a>
        </div>
        {!appliedGiftCode?.GiftCode && (
          <div
            className="listing-sidebar booking-sidebar mt-2"
            style={{ top: width <= 991 ? 0 : 100 }}
          >
            <div className="d-flex-space-between mb-3">
              <h4>Promo Code</h4>
            </div>
            <div className="d-flex-space-between mb-3 promocode-field position-relative">
              <input
                className="promo-input"
                type="text"
                name="PromoCode"
                placeholder="Enter Promo Code Here..."
                value={formik.values.PromoCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.values?.PromoCode && (
                <>
                  {promoapplyLoading && (
                    <div
                      className="spinner-border text-primary promo-apply-loading"
                      role="status"
                    />
                  )}
                  {appliedPromo?.PromoCode &&
                  appliedPromo?.PromoCode?.toLowerCase() ===
                    formik.values?.PromoCode?.toLowerCase()
                    ? !promoapplyLoading && (
                        <div className="promo-applied">
                          <span className="me-2">
                            <RxCrossCircled
                              className="promo-remove"
                              onClick={() => handlePromoCodeRemove()}
                            />
                          </span>
                          <span>Applied</span>
                        </div>
                      )
                    : !promoapplyLoading && (
                        <span
                          className="promo-apply"
                          onClick={() => handlePromoCodeApply()}
                        >
                          Apply
                        </span>
                      )}
                </>
              )}
            </div>
          </div>
        )}
        {!appliedPromo?.PromoCode && (
          <div className="listing-sidebar booking-sidebar mt-2">
            <div className="d-flex-space-between mb-3">
              <h4>Gift Code</h4>
            </div>

            <div className="d-flex-space-between mb-3 position-relative promocode-field">
              <input
                className="promo-input"
                type="text"
                name="GiftCode"
                placeholder="Enter Gift Code Here..."
                value={formik.values.GiftCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={showOtpModal}
              />

              {formik.values?.GiftCode && (
                <>
                  {giftcodeapplyLoading && (
                    <div
                      className="spinner-border text-primary promo-apply-loading"
                      role="status"
                    />
                  )}
                  {(appliedGiftCode &&
                    appliedGiftCode?.GiftCode?.toLowerCase()) ===
                  formik.values?.GiftCode?.toLowerCase()
                    ? !giftcodeapplyLoading && (
                        <div className="promo-applied">
                          <span className="me-2">
                            <RxCrossCircled
                              className="promo-remove"
                              onClick={handleGiftCodeRemove}
                            />
                          </span>
                          <span>Applied</span>
                        </div>
                      )
                    : !giftcodeapplyLoading && (
                        <span
                          className="promo-apply"
                          onClick={handleGiftCodeApply}
                        >
                          Apply
                        </span>
                      )}
                </>
              )}
            </div>

            <Modal
              isOpen={showOtpModal}
              onClose={() => {
                setShowOtpModal(false);
                formik.setFieldValue("GiftCodeOtp", "");
              }}
              title={"Verify Gift Code"}
              maxWidth={450}
            >
              <div>
                <p className="text-muted mb-3">
                  An OTP has been sent to the gift code owner. Please enter it
                  below to verify.
                </p>

                <input
                  className="mb-3 giftcode-otp-input"
                  type="text"
                  name="GiftCodeOtp"
                  placeholder="Enter OTP"
                  value={formik.values.GiftCodeOtp}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onInput={(e: any) => {
                    return (e.target.value = Math.max(
                      0,
                      parseInt(e.target.value)
                    )
                      .toString()
                      .slice(0, 4));
                  }}
                />

                <div className="d-flex justify-content-end gap-2">
                  <button
                    className="cancel-btn"
                    onClick={() => {
                      setShowOtpModal(false);
                      formik.setFieldValue("GiftCodeOtp", "");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="submit-btn"
                    disabled={giftcodeapplyLoading}
                    onClick={handleGiftCodeOtpVerify}
                  >
                    {giftcodeapplyLoading ? "Verifying..." : "Verify & Apply"}
                  </button>
                </div>
              </div>
            </Modal>

            {appliedGiftCodeAmount > 0 && (
              <div className="gift-applied-info mt-2">
                {totalAmount >= appliedGiftCode?.MinAmtUsage ? (
                  <p className="m-0 text-success fw-700">
                    Max usable: ₹{" "}
                    {formatIndianNumber(appliedGiftCode?.MaxAmtUsage)}
                  </p>
                ) : (
                  <p className="m-0 text-danger fw-700">
                    ₹ {formatIndianNumber(appliedGiftCode?.MinAmtUsage)} will be
                    used
                  </p>
                )}
              </div>
            )}
          </div>
        )}

        {walletDetails?.wallet_balance > 0 && (
          <div
            className="listing-sidebar booking-sidebar mt-2"
            style={{ top: width <= 991 ? 0 : 100 }}
          >
            <div className="d-flex-space-between mb-3">
              <h4>Wallet Balance</h4>
              <h4>₹ {formatIndianNumber(walletDetails?.wallet_balance)}</h4>
            </div>

            <div className="d-flex align-items-center mb-3">
              <input
                type="checkbox"
                id="useWallet"
                checked={useWallet}
                onChange={handleWalletToggle}
                className="me-2"
              />
              <label htmlFor="useWallet" className="cursor-pointer">
                Use Wallet Balance
              </label>
            </div>

            {useWallet && (
              <div className="mb-3">
                <label htmlFor="walletAmount" className="form-label">
                  Amount to use (max ₹{" "}
                  {formatIndianNumber(
                    Math.min(
                      walletDetails?.wallet_balance,
                      payableAmount + walletAmount
                    )
                  )}
                  )
                </label>
                <input
                  type="number"
                  id="walletAmount"
                  className="form-control"
                  value={walletAmount}
                  onChange={handleWalletAmountChange}
                  min="0"
                  max={Math.min(
                    walletDetails?.wallet_balance,
                    payableAmount + walletAmount
                  )}
                />
              </div>
            )}
          </div>
        )}

        {availableCreditLimit > 0 && (
          <div
            className="listing-sidebar booking-sidebar mt-2"
            style={{ top: width <= 991 ? 0 : 100 }}
          >
            <div className="d-flex-space-between mb-3">
              <h4>Credit Limit</h4>
              <h4>₹ {formatIndianNumber(availableCreditLimit)}</h4>
            </div>

            <div className="d-flex align-items-center mb-3">
              <input
                type="checkbox"
                id="useCreditLimit"
                checked={useCreditLimit}
                onChange={handleCreditLimitToggle}
                className="me-2"
              />
              <label htmlFor="useCreditLimit" className="cursor-pointer">
                Use Credit Limit
              </label>
            </div>

            {useCreditLimit && (
              <div className="mb-3">
                <label htmlFor="creditLimitAmount" className="form-label">
                  Amount to use (max ₹{" "}
                  {formatIndianNumber(
                    Math.min(
                      availableCreditLimit,
                      payableAmount + creditLimitAmount
                    )
                  )}
                  )
                </label>
                <input
                  type="number"
                  id="creditLimitAmount"
                  className="form-control"
                  value={creditLimitAmount}
                  onChange={handleCreditLimitAmountChange}
                  min="0"
                  max={Math.min(
                    availableCreditLimit,
                    payableAmount + creditLimitAmount
                  )}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewPriceCard;
